import React from 'react';
import Profile from 'containers/Profile';

const ProfilePage = (props) => <Profile {...props} />;

export default ProfilePage;
